<template>
  <b-form class="col-md-12 px-0 page-section pt-0" @submit.prevent="onSubmit">
    <b-form-group
      label="Organization"
      label-for="organization"
      label-class="form-label"
      v-if="getLoggedInUser.role === USER_ROLES.SUPER_ADMIN"
    >
      <v-select
        id="organization"
        class="form-control v-select-custom"
        label="name"
        v-model="research.org"
        :reduce="(opt) => opt.id"
        placeholder="Select Organization (optional)"
        :options="allOrgs"
        :loading="areOrgsLoading"
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-flex align-items-center">
            <fmv-avatar :title="true" title-class="bg-transparent" rounded no-link slot="aside" size="xs">
              <b-img :src="option.logo_url" class="img-fluid" width="20" alt="Logo" v-if="option.logo_url" />
              <i class="fas fa-university fa-lg" v-else></i>
            </fmv-avatar>
            <span>{{ option.name }}</span>
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          {{ option.name }}
        </template>
      </v-select>
    </b-form-group>

    <page-separator title="Feature this research for" />

    <b-form-group class="row-align-items-center">
      <label class="form-label">
        Universities <span class="text-muted">(optional)</span>
        <i
          class="material-icons icon-16pt clickable-item text-muted"
          v-b-popover.hover.top="`Select universities this research opportunity should be featured for.`"
          >info</i
        >
      </label>
      <v-select
        id="universities"
        class="form-control v-select-custom"
        label="name"
        v-model="research.universities"
        :reduce="(opt) => opt.id"
        placeholder="Select Universities"
        :options="allUniversities"
        :loading="areUnisLoading"
        multiple
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-flex align-items-center">
            <fmv-avatar :title="true" title-class="bg-transparent" rounded no-link slot="aside" size="xs">
              <b-img :src="option.small_logo_url" class="img-fluid" width="20" alt="Logo" v-if="option.small_logo_url" />
              <i class="fas fa-university fa-lg" v-else></i>
            </fmv-avatar>
            <span>{{ option.name }}</span>
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          {{ option.name }}
        </template>
      </v-select>
    </b-form-group>

    <b-form-group label="Associated Programs" label-for="associated_programs" label-class="form-label">
      <v-select
        id="associated_programs"
        class="form-control v-select-custom"
        label="title"
        v-model="research.associated_programs"
        :reduce="(program) => program.id"
        placeholder="Select Programs"
        :options="allPrograms"
        :loading="areProgramsLoading"
        multiple
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
        <template slot="option" slot-scope="option">
          <span>{{ option.title }}</span>
        </template>
      </v-select>
    </b-form-group>
  </b-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { FmvAvatar } from 'fmv-avatar';
import { USER_ROLES } from '../../../common/constants';
import PageSeparator from '@/components/Ui/PageSeparator.vue';

export default {
  name: 'ResearchAudienceForm',

  components: { FmvAvatar, PageSeparator },

  props: {
    researchData: { type: Object, required: true },
    allUniversities: { type: Array, default: () => [] },
    areUnisLoading: { type: Boolean, default: false },
    allPrograms: { type: Array, default: () => [] },
    areProgramsLoading: { type: Boolean, default: false },
    allOrgs: { type: Array, default: () => [] },
    areOrgsLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      USER_ROLES,
      research: {
        org: null,
        universities: [],
        associated_programs: [],
      },
    };
  },

  validations() {
    return {
      research: {},
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },

  watch: {
    researchData: {
      handler() {
        this.research = {
          org: this.researchData.org || null,
          universities: this.researchData.universities || [],
          associated_programs: this.researchData.associated_programs || [],
        };
      },
      deep: true,
    },
  },

  methods: {
    validateFormData() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
        formData: { ...this.research },
      };
    },
  },
};
</script>
